import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {RouterModule} from '@angular/router';
import {TeamNavLinkGroupFeatureComponent} from './team-nav-link-group-feature.component';
import {ProgressSpinnerModule} from '../../../dumb/progress-spinner/progress-spinner.module';

@NgModule({
  declarations: [TeamNavLinkGroupFeatureComponent],
  imports: [CommonModule, RouterModule, MatIconModule, ProgressSpinnerModule],
  exports: [TeamNavLinkGroupFeatureComponent],
})
export class TeamNavLinkGroupFeatureModule {}
